/**
 * Created by Florin David on 06/08/2018.
 */

export const isGraphQLError = (
  error: Error | GraphQLError,
): error is GraphQLError => {
  return error && typeof error === 'object' && 'code' in error
}

/**
 * GraphQL error
 */
export default class GraphQLError extends Error {
  public graphql = true
  public code: string

  /**
   * Create new GraphQL
   *
   * @param {Error[]} errors
   */
  public constructor(errors: GqlError[] = []) {
    super(errors.map((error): string => error.message).join('\n'))
    this.code = errors[0]?.extensions.code
  }
}
